// Copyright (c) 2016 Wildcard Corp. www.wildcardcorp.com

var $ = require('jquery');
(<any>window).$ = $;
(<any>window).jQuery = $;

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { environment } from './environment'
import { enableProdMode } from '@angular/core';
import 'intl';
import 'intl/locale-data/jsonp/en';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/main.ts